// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: http://codemirror.net/LICENSE

(function(mod) {
  if (typeof exports == "object" && typeof module == "object") // CommonJS
    mod(require("../../lib/codemirror"));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
"use strict";

CodeMirror.defineMode('evolview', function() {

  var words = {};
  function define(style, string) {
    var split = string.split(' ');
    for(var i = 0; i < split.length; i++) {
      words[split[i]] = style;
    }
  };

  // Atoms
  define('atom', 'true false');

  // Keywords
  define('keyword', 
		  '!align ' + 
		  '!alignindividualcolumn ' + 
		  '!allcovered ' + 
		  '!alldomains ' + 
		  '!area ' + 
		  '!arlegendshapes ' + 
		  '!arlegendstyles ' + 
		  '!axis ' + 
		  '!barheightpct ' + 
		  '!barheightpx ' + 
		  '!bootstrapvaluestyle ' + 
		  '!bootstrapvaluestyles ' + 
		  '!byarea ' + 
		  '!byradii ' + 
		  '!byradius ' + 
		  '!byradiuses ' + 
		  '!checklinewidth ' + 
		  '!checklwd ' + 
		  '!colmargin ' + 
		  '!colorgradient ' + 
		  '!colorgradientheight ' + 
		  '!colorgradientmarklabel ' + 
		  '!colorgradientmarklabels ' + 
		  '!colorgradientpixelheight ' + 
		  '!colorgradientpixelwidth ' + 
		  '!colorgradientwidth ' + 
		  '!colors ' + 
		  '!colorspectrum ' + 
		  '!columlabelstyle ' + 
		  '!columnlabelstyle ' + 
		  '!columnmargin ' + 
		  '!columnplot ' + 
		  '!columnplots ' + 
		  '!columnwidth ' + 
		  '!colwidth ' + 
		  '!datamatrixcolumlabelstyle ' + 
		  '!datamatrixcolumnlabelstyle ' + 
		  '!decoposition ' + 
		  '!decowithbranch ' + 
		  '!decowithleaf ' + 
		  '!defaultstroke-width ' + 
		  '!defaultstrokecolor ' + 
		  '!defaultstrokewidth ' + 
		  '!domains ' + 
		  '!dotplot ' + 
		  '!dotplots ' + 
		  '!fan ' + 
		  '!fanplot ' + 
		  '!grid ' + 
		  '!gridlabel ' + 
		  '!grouplabel ' + 
		  '!grouplabels ' + 
		  '!groups ' + 
		  '!groups_class ' + 
		  '!heatmap ' + 
		  '!heatmapcolumnlabel ' + 
		  '!heatmapcolumnlabels ' + 
		  '!heatmapcolumnlables ' + 
		  '!heatmaps ' + 
		  '!height ' + 
		  '!ids ' + 
		  '!internal ' + 
		  '!itemheightpct ' + 
		  '!itemheightpx ' + 
		  '!kvs ' + 
		  '!lca ' + 
		  '!leafdecoposition ' + 
		  '!leafnodeids ' + 
		  '!legend ' + 
		  '!legendcolor ' + 
		  '!legendcolors ' + 
		  '!legends ' + 
		  '!legendshapes ' + 
		  '!legendstyle ' + 
		  '!legendstyles ' + 
		  '!legendtext ' + 
		  '!legendtexts ' + 
		  '!legendtitle ' + 
		  '!line ' + 
		  '!linestyle ' + 
		  '!lty ' + 
		  '!maxradius ' + 
		  '!maxvalue ' + 
		  '!minradius ' + 
		  '!minvalue ' + 
		  '!nodes ' + 
		  '!nodes2delete ' + 
		  '!oldinternalid ' + 
		  '!op ' + 
		  '!opacity ' + 
		  '!plotheight ' + 
		  '!plotheigth ' + 
		  '!plotwidth ' + 
		  '!radii ' + 
		  '!radius ' + 
		  '!radiuses ' + 
		  '!scalebycol ' + 
		  '!scalingbycol ' + 
		  '!scol ' + 
		  '!shadow ' + 
		  '!shape ' + 
		  '!shapes ' + 
		  '!showdata ' + 
		  '!showdatafontcolor ' + 
		  '!showdatafontitalic ' + 
		  '!showdatafontsize ' + 
		  '!showdatatextalign ' + 
		  '!showdatavalue ' + 
		  '!showdomainname ' + 
		  '!showdomainnames ' + 
		  '!showgrid ' + 
		  '!showgridlabel ' + 
		  '!showheatmapcolumnlabel ' + 
		  '!showheatmapcolumnlabels ' + 
		  '!showlegend ' + 
		  '!showlegends ' + 
		  '!showname ' + 
		  '!shownumbers ' + 
		  '!showshadow ' + 
		  '!showtext ' + 
		  '!showvalue ' + 
		  '!showvaluefontcolor ' + 
		  '!showvaluefontitalic ' + 
		  '!showvaluefontsize ' + 
		  '!showvalues ' + 
		  '!showvaluesfontcolor ' + 
		  '!showvaluesfontitalic ' + 
		  '!showvaluesfontsize ' + 
		  '!showvaluestextalign ' + 
		  '!showvaluetextalign ' + 
		  '!stripheightpct ' + 
		  '!stripheightpx ' + 
		  '!stroke-width ' + 
		  '!strokecolor ' + 
		  '!strokecolordefault ' + 
		  '!strokewidth ' + 
		  '!style ' + 
		  '!styles ' + 
		  '!temp ' + 
		  '!this ' + 
		  '!title ' + 
		  '!type ' + 
		  '!types ' + 
		  '!width ' +
		  '!timeline ' +
		  '!timelineaxis ' +
		  '!timelinelines ' +
		  '!timelinestrips ' +
		  '!colorrecycle ' +
		  '!recyclecolor ' +
		  '!logtransform ' +
		  '!gridlabels '  +
		  '!gridshades ' +
		  '!shadesbetweengridlines ' +
		  '!rowdatareorder ' +
		  '!reorder '
    );

  // Commands
  define('builtin', 
		  'annotation ' + 
		  'backgroundcolor ' + 
		  'bkcolor ' + 
		  'color ' + 
		  'colwidth ' + 
		  'fontalign ' + 
		  'fontbold ' + 
		  'fontcolor ' + 
		  'fontitalic ' + 
		  'fontorientation ' + 
		  'fontsize ' + 
		  'from ' + 
		  'grouplabel ' + 
		  'label ' + 
		  'linecolor ' + 
		  'linestyle ' + 
		  'linewidth ' + 
		  'margin ' + 
		  'marginpct ' + 
		  'namedcolumn ' + 
		  'place ' + 
		  'roundedcorner ' + 
		  'shape ' + 
		  'show ' + 
		  'size ' + 
		  'spacebetweencolumns ' + 
		  'strokewidth ' + 
		  'style ' + 
		  'text ' + 
		  'textalign ' + 
		  'textangle ' + 
		  'textcolor ' + 
		  'textitalic ' + 
		  'textorientation ' + 
		  'textsize ' + 
		  'to ' + 
		  'valuestohide ' + 
		  'valuetohide ' + 
		  'width ' +
		  'totaltime ' +
		  'timeunit ' +
		  'pos ' +
		  'ticks ' +
		  'tickcolors ' +
		  'tickstrokewidths ' +
		  'ticklabels ' +
		  'ticklabelstyle ' +
		  'grid ' +
		  'gridstyle '+
		  'lines ' +
		  'linepos ' +
		  'linestyle ' +
		  'linestyles ' +
		  'linewidth ' +
		  'linewidths ' +
		  'linelabel ' +
		  'linelabels ' +
		  'linelabelstyle ' +
		  'linelabelstyles ' +
		  'linelabelpos ' +
		  'times ' + 
		  'time ' +
		  'linecolors ' +
		  'op ' +
		  'opacity ' + 
		  'strips ' +
		  'stripcolors ' +
		  'stripcolor ' +
		  'striplabel ' +
		  'striplabels ' +
		  'striplabelstyle ' +
		  'striplabelstyles ' +
		  'striplabelpos ' +
		  'stripmarginpx ' +
		  'showtimeunit ' +
		  'replacewith ' +
		  'asc ' +
		  'desc ' +
		  'dotplotmode ' +
		  'dotplotshape ' +
		  'id '
		  );
  
  define("qualifier", 'vertical horizontal start end middle numeric check star rect circle triangle line ' +
		  'dashed ' +
		  'aliceblue ' +
		  'antiquewhite ' +
		  'aqua ' +
		  'aquamarine ' +
		  'azure ' +
		  'beige ' +
		  'bisque ' +
		  'black ' +
		  'blanchedalmond ' +
		  'blue ' +
		  'blueviolet ' +
		  'brown ' +
		  'burlywood ' +
		  'cadetblue ' +
		  'chartreuse ' +
		  'chocolate ' +
		  'coral ' +
		  'cornflowerblue ' +
		  'cornsilk ' +
		  'crimson ' +
		  'cyan ' +
		  'darkblue ' +
		  'darkcyan ' +
		  'darkgoldenrod ' +
		  'darkgray ' +
		  'darkgrey ' +
		  'darkgreen ' +
		  'darkkhaki ' +
		  'darkmagenta ' +
		  'darkolivegreen ' +
		  'darkorange ' +
		  'darkorchid ' +
		  'darkred ' +
		  'darksalmon ' +
		  'darkseagreen ' +
		  'darkslateblue ' +
		  'darkslategray ' +
		  'darkslategrey ' +
		  'darkturquoise ' +
		  'darkviolet ' +
		  'deeppink ' +
		  'deepskyblue ' +
		  'dimgray ' +
		  'dimgrey ' +
		  'dodgerblue ' +
		  'firebrick ' +
		  'floralwhite ' +
		  'forestgreen ' +
		  'fuchsia ' +
		  'gainsboro ' +
		  'ghostwhite ' +
		  'gold ' +
		  'goldenrod ' +
		  'gray ' +
		  'grey ' +
		  'green ' +
		  'greenyellow ' +
		  'honeydew ' +
		  'hotpink ' +
		  'indianred ' +
		  'indigo ' +
		  'ivory ' +
		  'khaki ' +
		  'lavender ' +
		  'lavenderblush ' +
		  'lawngreen ' +
		  'lemonchiffon ' +
		  'lightblue ' +
		  'lightcoral ' +
		  'lightcyan ' +
		  'lightgoldenrodyellow ' +
		  'lightgray ' +
		  'lightgrey ' +
		  'lightgreen ' +
		  'lightpink ' +
		  'lightsalmon ' +
		  'lightseagreen ' +
		  'lightskyblue ' +
		  'lightslategray ' +
		  'lightslategrey ' +
		  'lightsteelblue ' +
		  'lightyellow ' +
		  'lime ' +
		  'limegreen ' +
		  'linen ' +
		  'magenta ' +
		  'maroon ' +
		  'mediumaquamarine ' +
		  'mediumblue ' +
		  'mediumorchid ' +
		  'mediumpurple ' +
		  'mediumseagreen ' +
		  'mediumslateblue ' +
		  'mediumspringgreen ' +
		  'mediumturquoise ' +
		  'mediumvioletred ' +
		  'midnightblue ' +
		  'mintcream ' +
		  'mistyrose ' +
		  'moccasin ' +
		  'navajowhite ' +
		  'navy ' +
		  'oldlace ' +
		  'olive ' +
		  'olivedrab ' +
		  'orange ' +
		  'orangered ' +
		  'orchid ' +
		  'palegoldenrod ' +
		  'palegreen ' +
		  'paleturquoise ' +
		  'palevioletred ' +
		  'papayawhip ' +
		  'peachpuff ' +
		  'peru ' +
		  'pink ' +
		  'plum ' +
		  'powderblue ' +
		  'purple ' +
		  'red ' +
		  'rosybrown ' +
		  'royalblue ' +
		  'saddlebrown ' +
		  'salmon ' +
		  'sandybrown ' +
		  'seagreen ' +
		  'seashell ' +
		  'sienna ' +
		  'silver ' +
		  'skyblue ' +
		  'slateblue ' +
		  'slategray ' +
		  'slategrey ' +
		  'snow ' +
		  'springgreen ' +
		  'steelblue ' +
		  'tan ' +
		  'teal ' +
		  'thistle ' +
		  'tomato ' +
		  'turquoise ' +
		  'violet ' +
		  'wheat ' +
		  'white ' +
		  'whitesmoke ' +
		  'yellow ' +
		  'yellowgreen ' +
		  'asc ' +
		  'desc ' +
		  '* '
		  );

  function tokenBase(stream, state) {
    if (stream.eatSpace()) return null;

    var sol = stream.sol();
    var ch = stream.next();

    if (ch === '#') {
      stream.skipToEnd();
      return 'comment';
    }
    if (ch === '=' || ch === ',') {
      return 'operator';
    }
    if(stream.match(/^\-?[\d\.]/,false)){
    	if(stream.match(/^(\-?(\d*\.\d+(e[+-]?\d+)?|\d+\.\d*)|0x[\da-fA-F]+|0b[01]+|\d+(e[+-]?\d+)?)/)){
    		return 'number';
    	}
    }
    stream.eatWhile(/[\w-]/);
    var cur = stream.current().toLowerCase(); // !! Dec 22, 2015; Add this line to make all keywords search case-insensitive ... 
    return words.hasOwnProperty(cur) ? words[cur] : null;
  }

  function tokenString(quote) {
    return function(stream, state) {
      var next, end = false, escaped = false;
      while ((next = stream.next()) != null) {
        if (next === quote && !escaped) {
          end = true;
          break;
        }
        if (next === '$' && !escaped && quote !== '\'') {
          escaped = true;
          stream.backUp(1);
          state.tokens.unshift(tokenDollar);
          break;
        }
        escaped = !escaped && next === '\\';
      }
      if (end || !escaped) {
        state.tokens.shift();
      }
      return (quote === '`' || quote === ')' ? 'quote' : 'string');
    };
  };

  var tokenDollar = function(stream, state) {
    if (state.tokens.length > 1) stream.eat('$');
    var ch = stream.next(), hungry = /\w/;
    if (ch === '{') hungry = /[^}]/;
    if (ch === '(') {
      state.tokens[0] = tokenString(')');
      return tokenize(stream, state);
    }
    if (!/\d/.test(ch)) {
      stream.eatWhile(hungry);
      stream.eat('}');
    }
    state.tokens.shift();
    return 'def';
  };

  function tokenize(stream, state) {
    return (state.tokens[0] || tokenBase) (stream, state);
  };

  return {
    startState: function() {return {tokens:[]};},
    token: function(stream, state) {
      return tokenize(stream, state);
    },
    lineComment: '#',
    fold: "brace"
  };
});

CodeMirror.defineMIME('text/x-evolview', 'evolview');

});
